import fontSizes from "assets/stylesheets/modules/typography/font-sizes.module.scss";

export default fontSizes;
